module.exports = ".callback-container {\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n\n.status-box {\n  padding: 30px 20px;\n}\n\n.status-box i.large {\n  font-size: 5rem;\n  margin-bottom: 15px;\n}\n\n.status-box .preloader-wrapper {\n  margin-bottom: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/assinaturas/govbr-callback.component.css
// module id = ./src/app/assinaturas/govbr-callback.component.css
// module chunks = main